export { default as AcceptAdminInviteForm } from './admin/AcceptAdminInviteForm';
export { default as ResetPasswordForm } from './admin/ResetPasswordForm';
export { default as InviteUserForm } from './admin/InviteUserForm';
export { default as LoginForm } from './login/LoginForm';
export { default as PropertyDetailsForm } from './properties/PropertyDetailsForm';
export { default as ApplicationTypeForm } from './stakeholders/ApplicationTypeForm';
export { default as StakeholderDetailsForm } from './stakeholders/StakeholderDetailsForm';
export { default as UpdateUserForm } from './admin/UpdateUserForm';
export { default as ProfileForm } from './user/ProfileForm';
export { default as NewsArticleForm } from './contentManagement/NewsArticleForm';
export { default as StakeholderDocumentForm } from './stakeholders/StakeholderDocumentForm';
export { default as PropertyDocumentForm } from './properties/PropertyDocumentForm';


// WEBPACK FOOTER //
// ./src/forms/index.ts